import { TbReportAnalytics } from "react-icons/tb";
import { HiOutlineOfficeBuilding } from "react-icons/hi";
import { SiSpringsecurity } from "react-icons/si";
import { BsDatabaseFillCheck } from "react-icons/bs";
import { VscRunAll } from "react-icons/vsc";

export const headings = [
    {
        id: 1,
        text: "Macroeconomics",
        sub: true,
        icon: <VscRunAll />,
    },
    {
        id: 2,
        text: "Fundamentals of Financial Market",
        icon: <TbReportAnalytics />,
        color: "#a4a4a4",
    },
    {
        id: 3,
        text: "Investment Analysis and Portfolio Management",
        icon: <HiOutlineOfficeBuilding />,
        color: "#a4a4a4",
    },
    {
        id: 5,
        text: "Fundamentals of Project Finance, Structured Trade and Commodity Finance( FPFST-CF)",
        icon: <BsDatabaseFillCheck />,
        color: "#09aff4",
    },
    {
        id: 6,
        text: "Fundamentals of Corporate Finance",
        icon: <SiSpringsecurity />,
        color: "#15284a",
    },
    {
        id: 7,
        text: "Financial Statement Analysis",
        icon: <VscRunAll />,
    },
    {
        id: 9,
        text: "Credit Risk Analysis",
        icon: <VscRunAll />,
    },
    {
        id: 10,
        text: "International Trade Finance",
        icon: <VscRunAll />,
    },
    {
        id: 11,
        text: "Financial Modelling",
        icon: <VscRunAll />,
    },
    {
        id: 12,
        text: "Business Valuation",
        icon: <VscRunAll />,
    },
    {
        id: 13,
        text: "Deal Structuring",
        icon: <VscRunAll />,
    },
    {
        id: 14,
        text: "Enterprise Risk Management",
        icon: <VscRunAll />,
    },
];